import { useTheme } from "next-themes";
import type { User } from "firebase/auth";
import { Button } from "@/components/ui/button";
import { LogOut, Sun, Moon } from "lucide-react";

interface Props {
  user: User;
  onSignOut: () => void;
}

export function Header({ user, onSignOut }: Props) {
  const { resolvedTheme, setTheme } = useTheme();

  return (
    <header className="border-b border-border/60 bg-background/80 backdrop-blur-sm sticky top-0 z-40">
      <div className="max-w-5xl mx-auto px-4 h-14 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-lg bg-foreground flex items-center justify-center shrink-0">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-background">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
            </svg>
          </div>
          <span className="font-medium text-sm">Vanity Links</span>
          <span className="text-muted-foreground/50 text-xs hidden sm:inline">l.circlesup.com</span>
        </div>

        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setTheme(resolvedTheme === "dark" ? "light" : "dark")}
            className="h-8 w-8 text-muted-foreground"
          >
            {resolvedTheme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </Button>
          {user.photoURL && (
            <img
              src={user.photoURL}
              alt={user.displayName ?? "User"}
              className="w-7 h-7 rounded-full ring-1 ring-border"
            />
          )}
          <span className="text-sm text-muted-foreground hidden sm:inline">{user.email}</span>
          <Button variant="ghost" size="icon" onClick={onSignOut} className="h-8 w-8 text-muted-foreground">
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
